import { useListAllSubtypesQuery } from '@/app/services/projectSubtypeApi';
import EnableSharingTypeTable from '@/components/enableAllocationType/table/EnableAllocationTypeTable';
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';

function EnableSharingType() {
  const { data: subtypes } = useListAllSubtypesQuery();

  const { t } = useTranslation(['enableSharingType']);
  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        marginRight: '20px',
      }}
    >
      <Box display="flex" flexDirection="column" sx={{ mt: 3, mr: 3 }}>
        <Typography variant="h1" sx={{ marginBottom: 2 }}>
          {t('enable.allocation.type')}
          <Typography variant="subtitle2" sx={{ marginTop: 1, paddingRight: 8 }}>
            {t(
              'choose.the.allocation.types.that.will.be.displayed.in.the.association.of.expenses.vs.buildings.vs.allocation.type',
            )}
          </Typography>
        </Typography>
        <EnableSharingTypeTable rows={subtypes || []} />
      </Box>
    </div>
  );
}

export default EnableSharingType;
